import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary.tsx'

const container = document.getElementById('root') as HTMLElement

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  enableLogs: true,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_APP_VERSION || 'development',
  integrations: [
    Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] }),
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  beforeSend(event) {
    if (import.meta.env.PROD && event.exception) {
      const error = event.exception.values?.[0]
      if (
        error?.value?.includes('Test') ||
        error?.value?.includes('SentryTestTriggers')
      ) {
        return null
      }
    }
    return event
  },
})

if (import.meta.env.PROD && typeof __MAIN_CSS__ === 'string') {
  const shadowRoot = container.attachShadow({ mode: 'open' })

  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = __MAIN_CSS__
  shadowRoot.appendChild(link)
}

createRoot(container.shadowRoot ?? container).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
)
